import {SnackBarTemplateComponent} from "../../shared/components/snack-bar-template/snack-bar-template.component";
import {inject, Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  readonly #snackBar = inject(MatSnackBar)

  public showNotification(message: string, action: 'create' | 'update' | 'delete' | 'admin-server-error' | 'user-server-error' | 'error') {
    this.#snackBar.openFromComponent(SnackBarTemplateComponent, {
      data: {
        label: message,
        type: action
      },
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 3000
    });
  }

}
